import script from "./risk-leak-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./risk-leak-chart.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__